import { NgModule } from '@angular/core';
import { CountryAutocompleteComponent } from './country-autocomplete.component';

@NgModule({
  imports: [CountryAutocompleteComponent],
  exports: [CountryAutocompleteComponent]
})
export class CountryAutocompleteModule {}
